import React from 'react';
import { ActivityTrail } from '../../pages';

const ActivityTrailContainer = ({ closeModal }) => {
    return (
        <ActivityTrail
            closeModal={closeModal}
        />
    )
}
export default ActivityTrailContainer;